export default "__VITE_ASSET__CYybjL0s__"